import { render } from "./list.vue?vue&type=template&id=78a1a000&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=78a1a000&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-78a1a000"

export default script